module.exports = __webpack_public_path__ + "img/logo-twitter.81c2a578.svg";